import { create } from "zustand";
import { GemelDataFilteredView, ChartType } from "../components/GemelData/types";
import { ProductType } from "../interfaces/DTO/mislaka_xml_models";
import { stockExposureBuckets, getDefaultDisplayPreferences } from "../utils/fundsFormatter";

interface InvestigationFiltersStore {
  filters: GemelDataFilteredView;
  setFilters: (filters: GemelDataFilteredView) => void;
  updateFilters: (partial: Partial<GemelDataFilteredView>) => void;
}

// טען pinnedItems מ-localStorage
export const loadPinnedItems = (): Record<string, string[]> => {
  try {
    const saved = localStorage.getItem('gemelInvestigation_pinnedItems');
    if (saved) return JSON.parse(saved);
  } catch (error) {
    console.error('Failed to load pinnedItems from localStorage', error);
  }
  return getDefaultDisplayPreferences().pinnedItems;
};

export const useInvestigationFiltersStore = create<InvestigationFiltersStore>((set) => ({
  filters: {
    productType: ProductType.EDUCATION_FUND,
    buckets: stockExposureBuckets.map(b => b.label),
    charts: [ChartType.YieldBubbles],
    fundPopulations: [],
    yAxisField: undefined,
    handlers: [],
    subSpecializations: [],
    stockExposureRanges: [],
    foreignExposureRanges: [],
    currencyExposureRanges: [],
    displayPreferences: {
      ...getDefaultDisplayPreferences(),
      pinnedItems: loadPinnedItems(),
    },
    forGeneralPublic: undefined,
  },
  setFilters: (filters) => set({ filters }),
  updateFilters: (partial) =>
    set((state) => {
      const newFilters = { ...state.filters, ...partial };
      return { filters: newFilters };
    }),
}));
